export interface DocumentData {
  file: Blob;
  naam: string;
  documentType: string;
}
